$(document).ready(function() {
    var coveragesByCompany = $('#insurance_company_id').data('coverages') || {};

    // Quando a seguradora mudar
    $('#insurance_company_id').on('change', function() {
        var insuranceCompanyId = $(this).val();
        var coverageSelect = $('#coverage_id');

        coverageSelect.empty();
        coverageSelect.append('<option value="">Selecione uma opção</option>');
        $('#coverage_amount').val('R$ 0,00');

        var coverages = coveragesByCompany[insuranceCompanyId] || [];
        $.each(coverages, function(index, coverage) {
            coverageSelect.append('<option value="' + coverage.id + '">' + coverage.name + '</option>');
        });
    });

    // Quando a cobertura mudar, atualizar o valor
    $('#coverage_id').on('change', function() {
        var coverageId = $(this).val();
        if (coverageId) {
            $.ajax({
                url: '/coverages/' + coverageId + '/amount',
                dataType: 'json',
                success: function(data) {
                    var amount = parseFloat(data.amount) || 0;
                    var formatted = amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?=,))/g, '.');
                    $('#coverage_amount').val('R$ ' + formatted);
                }
            });
        } else {
            $('#coverage_amount').val('R$ 0,00');
        }
    });

    // Quando a seguradora de origem mudar (transferência)
    $('#origin_insurance_company_id').on('change', function() {
        var insuranceCompanyId = $(this).val();
        var currentCoverageSelect = $('#current_coverage_id');

        currentCoverageSelect.empty();
        currentCoverageSelect.append('<option value="">Selecione uma opção</option>');

        if (insuranceCompanyId) {
            $.ajax({
                url: '/coverages/by_insurance_company',
                data: { insurance_company_id: insuranceCompanyId },
                dataType: 'json',
                success: function(data) {
                    $.each(data, function(index, coverage) {
                        currentCoverageSelect.append('<option value="' + coverage.id + '">' + coverage.name + '</option>');
                    });
                }
            });
        }
    });

    // Ao gerar a apólice: o form já abre o PDF em nova aba
    $('form[action*="generate_policy"]').on('submit', function() {
        var $form = $(this);
        var $submitButton = $form.find('input[type="submit"], button[type="submit"]');

        showSuccessModal('Apólice gerada com sucesso! O PDF foi aberto em uma nova aba.');

        setTimeout(function() {
            $submitButton.prop('disabled', false).removeClass('disabled');
        }, 500);
    });

    function showSuccessModal(message) {
        var modalId = 'toastModalGeneratePolicy';
        $('#' + modalId).remove();

        var modalHtml = `
        <div class="modal fade" id="${modalId}" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Sucesso</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">${message}</div>
                </div>
            </div>
        </div>
    `;

        $('body').append(modalHtml);

        var modalElement = document.getElementById(modalId);
        var myModal = new bootstrap.Modal(modalElement, {});
        myModal.show();

        setTimeout(function() {
            myModal.hide();
        }, 10000);

        modalElement.addEventListener('hidden.bs.modal', function() {
            $(this).remove();
        });
    }
});